"use client";

import { useTranslation } from "@/hooks/localization/useTranslations";

interface StockAlertMessageProps {
  minStockQuantity: number;
}

const StockAlertMessage: React.FC<StockAlertMessageProps> = ({
  minStockQuantity,
}) => {
  const t = useTranslation();

  return (
    <div className="alert-banner">
      <p className="text m-0">
        ⚡ {t.hurry_up} {t.only} {minStockQuantity} {t.pieces_available}
      </p>
    </div>
  );
};

export default StockAlertMessage;
